import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./styles.scss";
import {
    FaPercentage,
    FaHandsHelping,
    FaQuestionCircle,
    FaCertificate,
    FaHistory,
} from "react-icons/fa";

import smartphoneImg from "./img/smartphone.png";
import shopeeBannerImg from "./img/img01.svg";
import iconShopee from "./img/icon-shopee.webp";
import logo from './img/logo-main.png';
import { useState, useEffect } from "react";
import {
    getAllPessoas,
} from "../services/api";

export default function LandingPage() {
    const [data, setData] = useState([]);
    const [query, setQuery] = useState("");

    const [loading, setLoading] = useState(true);
    const baseURL =
        process.env.NODE_ENV === "production"
            ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
            : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

    useEffect(() => {
        if (query.length === 0) {
            getAllPessoas().then(
                (response) => {
                    setData(response);
                    setLoading(false);
                },
                () =>
                    console.log("deu ruim")
            );
        }
    }, [query]);

    const cards = data?.map((pessoa) => ({
        nome: pessoa.nome,
        cidade: pessoa.city_state?.name || "",
        estado: pessoa.city_state?.uf || "",
        image_url: pessoa.image_url || "",
    })) || [];

    return (
        <>
            <Helmet title="Ofertas da Shopee" />

            <section className="shopee-banner">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <Image
                                src={shopeeBannerImg}
                                alt="Ofertas da Shopee"
                                className="illustration"
                                fluid
                            />
                        </Col>

                        <Col md={6} className="text-content-col">
                            <div className="text-content">
                                <h2>
                                    <span className="small-title">AS MELHORES</span>
                                    <span className="highlight">OFERTAS</span>
                                    <span className="highlight">DA SHOPEE</span>
                                </h2>

                                <p>
                                    Acompanhe os melhores cupons, descontos<br />
                                    e promoções na palma da sua mão,<br />
                                    de forma <span className="free">100% gratuita!</span>
                                </p>
                            </div>
                        </Col>
                    </Row>

                    {/* Botão desktop */}
                    <Row className="d-none d-md-block">
                        <Col className="button-wrapper">
                            <Button
                                className="cta-button"
                                onClick={() => {
                                    const section = document.getElementById("whatsapp-section");
                                    if (section) {
                                        section.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            >
                                QUERO PARTICIPAR
                            </Button>
                        </Col>
                    </Row>

                    {/* Bloco WhatsApp mobile */}
                    <div className="mobile-whatsapp-cta d-block d-md-none">
                        <div className="whatsapp-banner-card">
                            <h3 className="whatsapp-title">Quase lá!</h3>
                            <p className="whatsapp-subtitle">Clique no botão abaixo para participar:</p>
                            <a
                                href={`${baseURL}entrar?tipo=shopee`}
                                rel="noopener noreferrer"
                                className="whatsapp-button"
                            >
                                WhatsApp
                            </a>
                        </div>
                    </div>
                </Container>

                {/* Ícones Shopee flutuantes */}
                <img src={iconShopee} alt="Shopee Icon" className="shopee-icon icon-1" />
                <img src={iconShopee} alt="Shopee Icon" className="shopee-icon icon-2" />
                <img src={iconShopee} alt="Shopee Icon" className="shopee-icon icon-3" />
                <img src={iconShopee} alt="Shopee Icon" className="shopee-icon icon-4" />
            </section>

            {/* Bloco WhatsApp exclusivo para desktop */}
            <section id="whatsapp-section" className="section-whatsapp d-none d-md-block">
                <div className="whatsapp-card-container">
                    <div className="whatsapp-card">
                        <div className="image-absolute-wrapper">
                            <Image
                                src={smartphoneImg}
                                alt="Conversa no WhatsApp"
                                className="smartphone-img"
                                fluid
                            />
                        </div>

                        <Row className="justify-content-center text-center">
                            <Col md={8} className="text-content-col">
                                <div className="text-content">
                                    <h2 className="title">Falta pouco!</h2>
                                    <p className="subtitle">
                                        Clique no botão abaixo para participar:
                                    </p>
                                    <a
                                        href={`${baseURL}entrar?tipo=shopee`}
                                        rel="noopener noreferrer"
                                        className="whatsapp-button"
                                    >
                                        WhatsApp
                                    </a>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </section>
            <section className="section-compras">
                <Container fluid>
                    <div className="compras-marquee">
                        {cards.length === 0 ? (
                            <p className="text-center">Carregando compras recentes...</p>
                        ) : (
                            (() => {
                                const repeticoes = Math.ceil(12 / cards.length); // garante volume mínimo
                                const cardsComVolume = Array.from({ length: repeticoes }, () => cards).flat();

                                const linha1 = cardsComVolume.filter((_, i) => i % 2 === 0);
                                const linha2 = cardsComVolume.filter((_, i) => i % 2 !== 0);

                                const renderCard = (c, index, keyPrefix) => (
                                    <div className="compra-card" key={`${keyPrefix}-${index}`}>
                                        <div className="card-header">
                                            <span>COMPRA REALIZADA EM <b>NOSSOS GRUPOS</b></span>
                                            <span className="check">✔</span>
                                        </div>
                                        <div className="card-body">
                                            {c.image_url ? (
                                                <img
                                                    src={c.image_url}
                                                    alt={c.nome}
                                                    className="card-img"
                                                />
                                            ) : (
                                                <div className="avatar-placeholder">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 16 16">
                                                        <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                        <path fillRule="evenodd" d="M14 14s-1-1.5-6-1.5S2 14 2 14s1-4 6-4 6 4 6 4z" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>


                                        <div className="card-footer">
                                            <p>{c.nome}</p>
                                            <p>{c.cidade}/{c.estado}</p>
                                        </div>
                                    </div>
                                );

                                return (
                                    <>
                                        {/* Linha 1 */}
                                        <div className="compras-track left">
                                            {linha1.map((c, index) => renderCard(c, index, "linha1"))}
                                        </div>

                                        {/* Linha 2 */}
                                        <div className="compras-track right">
                                            {linha2.map((c, index) => renderCard(c, index, "linha2"))}
                                        </div>
                                    </>
                                );
                            })()
                        )}
                    </div>
                </Container>
            </section>




            <section className="section-vantagens">
                <Container>
                    <h2 className="title-vantagens text-center mb-5">QUAIS AS VANTAGENS?</h2>
                    <Row className="text-center justify-content-center gx-4 gy-4">

                        {/* 1. Promoções diárias */}
                        <Col xs={12} sm={6} md={3} className="d-flex">
                            <div className="vantagem-card white flex-fill">
                                <div className="icon-wrapper yellow-bg">
                                    <FaCertificate className="icon-back" />
                                    <FaPercentage className="icon-front" />
                                </div>
                                <h3>Promoções diárias</h3>
                                <p>
                                    Receba no conforto da sua casa as melhores promoções dos principais
                                    varejistas do Brasil!
                                </p>
                            </div>
                        </Col>

                        {/* 2. Apoio na compra */}
                        <Col xs={12} sm={6} md={3} className="d-flex">
                            <div className="vantagem-card yellow flex-fill">
                                <div className="icon-wrapper custom-blue-bg">
                                    <FaHandsHelping className="icon white large" />
                                </div>
                                <h3>Apoio na compra</h3>
                                <p>
                                    Conte conosco para garantir que fará uma excelente compra, com
                                    segurança e pagando barato!
                                </p>
                            </div>
                        </Col>

                        <Col xs={12} sm={6} md={3} className="d-flex">
                            <div className="vantagem-card white flex-fill">
                                <div className="icon-wrapper yellow-bg">
                                    {/* Círculo azul de fundo */}
                                    <div className="icon-back-circle" />
                                    {/* Ícone branco por cima */}
                                    <FaQuestionCircle className="icon-front question-icon" />
                                </div>
                                <h3>Tire suas dúvidas</h3>
                                <p>
                                    Tá com alguma dúvida sobre alguma oferta? Entre em contato conosco que iremos lhe ajudar!
                                </p>
                            </div>
                        </Col>





                        {/* 4. Histórico de preços */}
                        <Col xs={12} sm={6} md={3} className="d-flex">
                            <div className="vantagem-card yellow flex-fill">
                                <div className="icon-wrapper white-bg">
                                    <FaHistory className="icon white large" />
                                </div>
                                <h3>Histórico de preços</h3>
                                <p>
                                    Tá em dúvida se um produto tá barato? Confira nosso histórico de
                                    preços no Telegram!
                                </p>
                            </div>
                        </Col>

                    </Row>
                </Container>
            </section>

            <section className="section-quem-somos">
                <div className="container">
                    <Row className="align-items-center">
                        <Col xs={12}>
                            <h2 className="title-quem-somos text-center">QUEM SOMOS?</h2>
                        </Col>

                        <Col xs={12} md={6}>
                            <div className="video-container">
                                <iframe
                                    src="https://www.youtube.com/embed/VY2NEogxHVk"
                                    title="Vídeo YouTube"
                                    frameBorder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </Col>

                        <Col xs={12} md={6}>
                            <div className="quem-somos-text">
                                <p>
                                    Nascemos em 2020 com objetivo de ajudar os consumidores brasileiros
                                    a economizar em suas compras na internet!
                                </p>
                                <p>
                                    Contamos com grupos de ofertas gerais no WhatsApp e Telegram, com
                                    mais de 200 mil membros totais, além de mais de 100 mil inscritos no
                                    YouTube!
                                </p>
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>


            <div className="footer">
                <Container className="text-center">
                    <Image src={logo} alt="Caçadores de Ofertas" className="footer-logo" />
                    <br />
                    <br />
                    <p className="footer-text">© Caçadores de Ofertas 2022-2025<br />Todos os direitos reservados.</p>
                </Container>
            </div>
        </>
    );
}
